// PreAuthNotice.tsx — the pre-auth failure state (S2-B B2, decision A). One component, every
// pre-auth surface: an unknown host/id is 'not-found' (never Nova), botapi down is 'unavailable'.
import React from 'react';
import { PREAUTH_TEXT } from '../../utils/agentBootstrap';

export function PreAuthNotice({ status }: { status: 'not-found' | 'unavailable' | 'choose' }) {
  return (
    <div data-component="PreAuthNotice" data-status={status}
         style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif', maxWidth: 640 }}>
      <h2 style={{ marginBottom: '0.5rem' }}>{status === 'unavailable' ? 'Assistant unavailable' : 'Assistant not found'}</h2>
      <p style={{ lineHeight: 1.5 }}>{(PREAUTH_TEXT as any)[status]}</p>
    </div>
  );
}
